import React from 'react';
import { Route } from 'react-router';

import {
  App,
  LayoutApp
} from 'components';

import {
  Login,
  ForgotCredentialsModal
} from 'containers';

const LoginWithMessage = (props) => {
  // temporary Notification message; HTML markup permitted
  const notificationMessage = `

  `.trim();

  return <Login {...props} notificationMessage={notificationMessage} />;
};


export default () => {
  // we have multiple Routers; for precedence, see `server.js`
  return (
    <Route path="/" component={LayoutApp} >
      <Route path="/login(/:optional)" component={LoginWithMessage} />
      <Route path="/zen/login(/:optional)" component={LoginWithMessage} />
      <Route path="/forgot/password" component={ForgotCredentialsModal} />
      <Route path="/forgot/username" component={ForgotCredentialsModal} />
      <Route path="*" component={App} />
    </Route>
  );
};
